import { Outlet } from 'react-router-dom';
import { useAuth } from '@/store/AuthContext';
import { useSiteInfo } from '@/api/services/siteService';
import { SidebarMenu } from './SidebarMenu';
import { ProfileMenu } from './ProfileMenu';

export function DashboardLayout() {
  const { user } = useAuth();
  const { data: site } = useSiteInfo();

  return (
    <div className="d-flex min-vh-100 bg-surface">
      {/* Sidebar */}
      <aside
        className="d-none d-lg-flex flex-column flex-shrink-0 position-sticky top-0 vh-100 bg-surface-lowest"
        style={{ width: 260 }}
      >
        <div className="d-flex align-items-center gap-2 px-4 py-4">
          <span
            className="d-inline-flex align-items-center justify-content-center rounded-3 bg-primary text-white"
            style={{ width: 40, height: 40 }}
          >
            <i className="bi bi-printer fs-5" />
          </span>
          <span className="text-headline-sm text-on-surface">Kiosk Admin</span>
        </div>

        <div className="flex-grow-1 overflow-auto px-3 pb-3">
          <SidebarMenu items={user?.menu ?? []} />
        </div>

        {site?.website_url && (
          <div className="px-3 pb-3">
            <a
              href={site.website_url}
              target="_blank"
              rel="noopener noreferrer"
              className="d-flex align-items-center gap-2 px-3 py-2 rounded-3 text-decoration-none text-on-surface-variant text-label-md"
            >
              <i className="bi bi-box-arrow-up-right" />
              Visit website
            </a>
          </div>
        )}
      </aside>

      {/* Main */}
      <div className="flex-grow-1 d-flex flex-column" style={{ minWidth: 0 }}>
        <header className="sticky-top bg-surface d-flex align-items-center justify-content-end gap-3 px-4" style={{ height: 64, zIndex: 1020 }}>
          <div className="d-flex align-items-center gap-3">
            <button type="button" className="btn btn-link text-on-surface-variant p-0 position-relative tap-target" aria-label="Notifications">
              <i className="bi bi-bell fs-5" />
              <span className="position-absolute top-50 start-50 p-1 bg-danger rounded-circle" style={{ marginTop: -14, marginLeft: 2 }} />
            </button>
            <ProfileMenu />
          </div>
        </header>

        <main className="p-3 p-lg-4 flex-grow-1">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
